// accordion
document.addEventListener('DOMContentLoaded', () => {
  const $accordion = Array.prototype.slice.call(document.querySelectorAll('.js-accordion-title'), 0);
  if ($accordion.length > 0) {
    $accordion.forEach(el => {
      el.insertAdjacentHTML("beforeend", '<i class="js-accordion-arrow"></i>');
    });
  }
});

$(function () {
  $(".js-accordion .js-accordion-title,.header-nav-mobile-header .wp-block-navigation-submenu button").click(function () {
    $(this).next().slideToggle();
    $(this).toggleClass("is-accordion-open");
  });
});
